export default {
  title: 'Formularz kontaktowy',
  fillIn: 'Wypełnij wszystkie pola obowiązkowe',
  heading: 'Dane kontaktowe',
  name: 'Imię *',
  surname: 'Nazwisko *',
  email: 'Adres e-mail *',
  phone: 'Numer telefonu',
  heading2: 'Adres kontaktowy',
  street: 'Ulica *',
  number: 'Numer budynku *',
  city: 'Miasto',
  postalCode: 'Kod pocztowy *',
  info: 'Po otrzymaniu Twojego formularza kontaktowego w ciągu 3 dni odezwiemy się do Ciebie z atrakcyjną ofertą dostosowaną do twojego wolumenu. Gdy ją zaakceptujesz, możemy rozpocząć pracę nad szczegółami projektu, w tym harmonogramem, aby spełnić Twoje oczekiwania.',
  permit: `Administratorem danych osobowych, zawartych w formularzu kontaktowym („Formularz”) jest Nutricia Polska Sp. z o.o. z siedzibą w Warszawie (ul. Bobrowiecka 8, 00-728). 
  Wskazane w Formularzu dane będą przetwarzane w celu odpowiedzi na Państwa wniosek o wycenę, drogą telefoniczną i/ lub mailową, zgodnie z art. 6 ust. 1 lit.f RODO.Podanie danych jest dobrowolne, ale niezbędne do skorzystania z usługi Formularza.
  Wysłanie Zapytania przez Formularz będzie równoznaczne z wyrażeniem zgody na przetwarzanie danych osobowych podanych w Formularzu przez Nutricia Polska S.A.oraz otrzymanie odpowiedzi na przesłane zapytanie drogą mailową i / lub telefoniczną.
  Przysługuje Państwu prawo żądania dostępu do danych, ich sprostowania, usunięcia, ograniczenia, przenoszenia, cofnięcia zgody, wniesienia sprzeciwu oraz złożenia skargi. Pełne informacje w <b><a href="https://www.nutricia.com.pl/polityka-prywatnosci">„Polityce Prywatności”</a></b>.`,
  submit: 'Wyślij zapytanie',
  permitError: 'Zgoda jest wymagana',
  error: 'Pole jest wymagane',
};
